import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useAlert } from 'react-alert';
// query
import useAddDirectMessage from '../../../query/useAddDirectMessage';
// components
import FormSendImages from './form-send-images';
import Btn from '../button/btn';

export default function FormMessage({ isAdmin, memberId }) {
  const alert = useAlert();

  const refTextarea = useRef({});

  const [submitDisabled, setSubmitDisabled] = useState(true);

  const textareaSimulator = useMemo(() => document.createElement('textarea'), []);

  const [addMessage, addMessageQuery] = useAddDirectMessage();

  const handleSubmit = (e) => {
    e.preventDefault();

    addMessage(
      {
        memberId,
        content: refTextarea.current.value,
        sender: isAdmin ? 'admin' : 'member',
      },
      {
        onSuccess: (response) => {
          const { status, message } = response.data;

          if (status === 'ok') {
            refTextarea.current.value = null;
            setSubmitDisabled(true);
            handleTextareaChange();
          } else {
            alert.error(message);
          }
        },
        onError: () => {
          alert.error('ارسال پیام شما با خطا مواجه شد');
        },
      },
    );
  };

  const handleTextareaChange = () => {
    setTimeout(() => {
      if (refTextarea.current) {
        // When close comment area, refTextarea will be destroyed. So we must check refTextarea existing after 10ms.
        textareaSimulator.value = refTextarea.current.value;

        const height = textareaSimulator.scrollHeight < 80 ? textareaSimulator.scrollHeight : 80;
        refTextarea.current.style.height = height + 'px';

        if (height === 80) {
          refTextarea.current.classList.remove('o-hidden');
          refTextarea.current.classList.add('o-auto');
        } else {
          refTextarea.current.classList.remove('o-auto');
          refTextarea.current.classList.add('o-hidden');
        }

        setSubmitDisabled(refTextarea.current.value.length === 0);
      }
    }, 0);
  };

  useEffect(() => {
    if (refTextarea.current) {
      textareaSimulator.style.cssText = `width: ${refTextarea.current.offsetWidth}px; height: 19px; padding: 0;`;
      textareaSimulator.classList.add('simulator-textarea');
      document.body.appendChild(textareaSimulator);
    }

    return () => {
      textareaSimulator.remove();
    };

    // eslint-disable-next-line
  }, []);

  return (
    <div className="sm-comments form-direct-message">
      <section className="comment-form direct f-row f-shrink-0 justify-content-center" style={{ borderBottom: 'none' }}>
        <div className="form-area f-grow-1 f-shrink-0 justify-content-center">
          <form
            className="d-flex f-row align-items-center f-grow-1 f-shrink-1 p-relative"
            method="post"
            onSubmit={handleSubmit}
          >
            <textarea
              className="input d-flex f-grow-1 plho"
              placeholder="پیام خود را بنویسید"
              ref={refTextarea}
              disabled={addMessageQuery.isLoading}
              onChange={handleTextareaChange}
              onKeyDown={handleTextareaChange}
            />
            <Btn
              type={'submit'}
              className={'submit-blue-btn'}
              disabled={submitDisabled}
              loading={addMessageQuery.isLoading}
              loadingFill={'#555'}
            >
              ارسال
            </Btn>
          </form>
        </div>
        <div className="send-images f-shrink-0">
          <FormSendImages memberId={memberId} sender={isAdmin ? 'admin' : 'member'} />
        </div>
      </section>
    </div>
  );
}
